import { Injectable } from '@angular/core';
import { AlertHelper } from '../alert/alert.helper';
import { FileExtension, FileUtils } from '../util/file-utils';

@Injectable({
  providedIn: 'root'
})
export class FileService {

  constructor(
    private alertHelper: AlertHelper,
  ) { }

  public async loadFileWithErrorHandling(...fileExtensions: FileExtension[]): Promise<File | undefined> {
    try {
      return await FileUtils.loadFile(...fileExtensions);
    } catch(error) {
      FileUtils.handleFileLoadingError(error, this.alertHelper);
    }
  }
}
